export const clearUrl = (location: string) => {
    const url = new URL(location)

    url.search = ''
    url.hash = ''

    window.history.replaceState({}, document.title, url.pathname + url.search)
}
